import React from 'react';
import HamHeader from '../Header/HamburgerHeader';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';
import style from './sensors.module.scss';
import TableSensors from './TableSensors/index';
import SearchIcon from '@assets/images/Fireboard/Search';
import NamedSensors from './NamedSensor';
import { ReactComponent as PlusIcon } from '@assets/images/Fireboard/PlusIcon.svg';
import { goToView } from '../../../../utility/fireboardUtil';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const Search = ({ fieldValue, setFieldValue, isNamed }) => {
  return (
    <div className="col-12 d-flex flex-column align-items-center justify-content-center mb-3 py-1">
      <form className="col-5 px-0 position-relative">
        <input
          type="text"
          value={fieldValue}
          onChange={e => setFieldValue(e.target.value)}
          className={cn(
            'col-12 pl-3 pr-5',
            isNamed ? style.searchInputNamed : style.searchInput
          )}
          placeholder={FLABEL().TABLE_SENSOR_SEARCH}
        />
        <div className={style.searchIcon}>
          <SearchIcon />
        </div>
      </form>
    </div>
  );
};
const SensorsComponent = props => {
  const {
    selectedSensorTab,
    OnChangeTab,
    fieldValue,
    setFieldValue,
    onClickAddSensor,
    currentView,
  } = props;
  const navigate = useNavigate();

  const tabOptions = [
    { key: 'table', label: FLABEL().HEADER_TABLE },
    { key: 'named', label: FLABEL().HEADER_NAMED },
  ];

  const Tabs = () => {
    return (
      <div className={cn('d-flex', style.tabContainers)}>
        {tabOptions.map(({ key, label }) => (
          <div
            key={key}
            role="tab"
            aria-selected={selectedSensorTab === key}
            className={cn(
              'col-6 d-flex justify-content-center align-items-center',
              selectedSensorTab === key && style.selectedSensorTab
            )}
            onClick={() => {
              OnChangeTab(key);
            }}
          >
            {label}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="h-100">
      <div className="mb-3">
        <HamHeader
          filterElement={Tabs}
          label={
            selectedSensorTab === 'table'
              ? FLABEL().HEADER_TABLE_SENSORS
              : FLABEL().HEADER_NAMED_SENSORS
          }
          onClickback={() => goToView(currentView, navigate)}
        />
      </div>

      {selectedSensorTab === 'table' && (
        <>
          <Search fieldValue={fieldValue} setFieldValue={setFieldValue} />
          <TableSensors {...props} />
        </>
      )}
      {selectedSensorTab === 'named' && (
        <div className={cn(style.namedSensorsConatiner, 'col-12')}>
          <div className="d-flex position-relative">
            <Search
              fieldValue={fieldValue}
              setFieldValue={setFieldValue}
              isNamed
            />
            <div
              className={cn(
                style.addBtn,
                'd-flex justify-content-center align-items-center mt-1'
              )}
              onClick={() => onClickAddSensor()}
            >
              <span className="col-9 px-0 text-center text-nowrap">
                {FLABEL().NAMED_SENSOR}
              </span>
              <span className={cn(style.addIcon, 'pl-2')}>
                <PlusIcon />
              </span>
            </div>
          </div>
          <NamedSensors {...props} />
        </div>
      )}
    </div>
  );
};
export default SensorsComponent;
